export enum MenuEnum {
  NEW = 1, UNDO, REDO, SUGGESTIONS, TEXT_ALIGNMENT, TEXT_FONT_FAMILY, TEXT_FONT_SIZE, TEXT_FONT_WEIGHT, TEXT_FONT_STYLE, TEXT_DECORATION,
  UNORDERED_LIST, ORDERED_LIST, MICROPHONE
}
